'use strict';
import {getLink} from '../../core-utilities/domain/ReduxUtils';
import {TaskType} from '../../tasks/enums/TaskType';


export const MILESTONE_CLASS_NAME = 'MilestoneDomain';
export const MILESTONE_COLLECTION = 'milestones';
export const PLACEHOLDER_MILESTONE = {
  id: 'misc',
  collection: MILESTONE_COLLECTION,
  $id: 'misc',
  name: 'placeholder',
  $class: {COLLECTION: MILESTONE_COLLECTION}
};

export function MilestoneDomainProvider() {
  return {
    $get: [
      'FirebaseUtil',
      'AuthService',
      'AbstractDomainClass',
      'OrgIdMixin',
      '$filter',
      'restUtils',
      function (FirebaseUtil, AuthService, AbstractDomainClass, OrgIdMixin, $filter, restUtils) {
        function MilestoneDomain(data) {
          AbstractDomainClass.call(this, MilestoneDomain, data);
        }

        AbstractDomainClass.__inheritFrom(MilestoneDomain, MILESTONE_CLASS_NAME, MILESTONE_COLLECTION);
        OrgIdMixin(MilestoneDomain);
        MilestoneDomain.PLACEHOLDER_MILESTONE = PLACEHOLDER_MILESTONE;

        MilestoneDomain.$constraints.addConstraints({
          name: {type: 'string'},
          description: {type: 'string', widget: 'textarea', nullable: true},
          assetSpecific: {type: 'boolean', defaultValue: false},
          project: {type: 'Domain', domainClass: 'ProjectDomain'},
          org: {type: 'string'}, // Organization ID
          createdBy: {type: 'DomainLink', domainClass: 'UserDomain', nullable: true},
          dateCreated: {type: 'Date'},
          lastUpdated: {type: 'Date'},

          members: {type: 'DomainCollection', domainClass: 'UserDomain'},
          tasks: {type: 'DomainCollection', domainClass: 'TaskDomain', link: 'milestone', belongsTo: true},
          assetTasks: {type: 'DomainCollection', domainClass: 'AssetTaskDomain', link: 'milestone', belongsTo: true}
        });

        // for fallback API methods
        MilestoneDomain.fallbackIdProperty = 'milestoneId';
        MilestoneDomain.createFallbackMethod = 'milestones/create';
        MilestoneDomain.updateFallbackMethod = 'milestones/update';

        // more methods go here;

        MilestoneDomain.filterMilestoneListByTaskType = function filterMilestoneByTaskType(taskType) {
          return function filterMilestoneByTaskTypeInternal(milestones) {
            const filteredMilestones = {};

            for (let id in milestones) {
              if (milestones.hasOwnProperty(id)) {
                const milestone = milestones[id];
                if (!milestone) continue;
                if (!milestone.assetSpecific && taskType === TaskType.PROJECT) {
                  filteredMilestones[id] = milestone;
                } else if (milestone.assetSpecific && (taskType === TaskType.ASSET || taskType === TaskType.TEMPLATE)) {
                  filteredMilestones[id] = milestone;
                }
              }
            }

            return filteredMilestones;
          }
        };

        MilestoneDomain.prototype.create = restUtils.createProto(MilestoneDomain, {
          getBody: instance => ({
            name: instance.name,
            description: instance.description,
            /*isPrivate: this.isPrivate,*/
            orgId: instance.org,
            projectId: getLink(instance, 'project').id,
            assetSpecific: instance.assetSpecific,
          }),
        });

        MilestoneDomain.prototype.update = restUtils.updateProto(MilestoneDomain);

        MilestoneDomain.prototype.toString = function () {
          return this.name;
        };

        MilestoneDomain.prototype.toDescriptiveString = function toDescriptiveString() {
          return `${this} - ${this.project}`
        };

        return MilestoneDomain;
      }]
  };
}



// WEBPACK FOOTER //
// ./src/js/projects/domain/MilestoneDomain.js